<template>
  <div>
    <el-button
      @click="downloadData('sample.json')"
      class="w-100"
      type="primary"
      size="large"
    >
      Download data
    </el-button>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'app-builder-download-data-button',

  methods: {
    ...mapActions({
      downloadData: 'builder/downloadData',
    }),
  },
};
</script>

<style></style>
